module.exports = __webpack_public_path__ + "static/media/sell_teach_7.2a9abdd2.png";